import { pageUrl } from "@config"
import navLogoImg from "@images/gamesPage/40aa.png"
import badgeTipImg from "@images/gamesPage/44aa.png"
import Clickable from "@src/components/clickable"
import Nav from "@src/components/nav"
import GamesList from "@src/components/pages/games/gamesList"
import Guests from "@src/components/pages/games/guests"
import Header from "@src/components/pages/games/header"
import Judge from "@src/components/pages/games/judge"
import Xiaohongshu from "@src/components/pages/games/xiaohongshu"
import SideAnimationContainer from "@src/components/sideAnimationContainer"
import Tabs from "@src/components/tabs"
import { wxShare } from "@src/utils/wechat"
import { shareInApp } from "@utils/request"
import React, { useEffect, useRef } from "react"
import * as styles from "./games.module.scss"

const TABS = [
  { key: "games", title: "游戏库" },
  { key: "judge", title: "评选标准" },
  { key: "xiaohongshu", title: "小红书活动" },
]

const renderBody = (key) => {
  if (key === "games") {
    return <GamesList />
  }
  if (key === "judge") {
    return <Judge />
  }
  if (key === "xiaohongshu") {
    return <Xiaohongshu />
  }
}

const Games = () => {
  const navShowRef = useRef()
  useEffect(() => {
    wxShare({
      title: "BOOOM 线上试玩&评选会",
      link: `${pageUrl}games`,
    })
  }, [])
  return (
    <>
      <Nav
        logo={navLogoImg}
        buttonProps={{
          to: "/",
          children: "返回主站",
        }}
        showWhenRef={navShowRef}
        extraRight={
          <Clickable
            style={{ marginLeft: 10 }}
            onClick={() => {
              shareInApp()
            }}
          >
            分享
          </Clickable>
        }
      />
      <Header />
      <p className={styles.badgeTip} ref={navShowRef}>
        <img src={badgeTipImg} alt="badge" />
      </p>
      <Guests />
      <SideAnimationContainer direction="right" mount={3000}>
        <div className="container0">
          <Tabs tabs={TABS} render={renderBody} />
        </div>
      </SideAnimationContainer>
    </>
  )
}

export default Games
